// Display names for plan ids ("pro" → "Pro"); unknown ids pass through.
const PLAN_NAMES = {
  trial: 'Free trial',
  starter: 'Starter',
  basic: 'Basic',
  pro: 'Pro',
  vip: 'VIP',
};

export default function planName(plan) {
  return PLAN_NAMES[plan] || plan;
}
